import { Box, Card, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import JoinInnerOutlinedIcon from '@mui/icons-material/JoinInnerOutlined';

const aboutLocales = "about";

const AboutStatement = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                className="sectionDoubleSpacing"
                sx={{
                    backgroundColor: theme.palette.background.paper
                }}
            >
                <Box 
                    className="sectionInSidePadding"
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        px: 0
                    }}
                >
                    <Grid
                        className="bodySideMargin1 sectionRadius"
                        direction='row'
                        container
                        spacing={{xs: 1.5, md: 3}}
                        sx={{
                            backgroundColor: theme.palette.background.default
                        }}
                    >
                        <Grid
                            size={{xs: 12, md: 4}}
                        >
                            <StatementBox 
                                index={0}
                                title={t(`${aboutLocales}.vision.title`)}
                                description={t(`${aboutLocales}.vision.description`)}
                                icon={<RemoveRedEyeOutlinedIcon color="primary" sx={{pt: 0.5, width: 30, height: 30}}/>}
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 4}}
                        >
                            <StatementBox 
                                index={1}
                                title={t(`${aboutLocales}.mission.title`)}
                                description={t(`${aboutLocales}.mission.description`)}
                                icon={<FlagOutlinedIcon color="primary" sx={{pt: 0.5, width: 30, height: 30}}/>}
                                inverse
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 4}}
                        >
                            <StatementBox 
                                index={2}
                                title={t(`${aboutLocales}.values.title`)}
                                description={t(`${aboutLocales}.values.description`)}
                                icon={<JoinInnerOutlinedIcon color="primary" sx={{pt: 0.5, width: 30, height: 30}}/>}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}

export default AboutStatement;

const StatementBox = ({
    index,
    title,
    description,
    icon,
    inverse=false
}) => {
    const theme = useTheme();

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    p: {xs: 2, md: 5},
                    backgroundColor: inverse ? theme.palette.primary.main : theme.palette.background.default,
                    border: `0.5px solid ${theme.palette.primary.main}`,
                    borderRadius: {xs: 4, md: 8},
                    minHeight: {xs: 0, md: 250}
                }}
                data-aos="zoom-in"
                data-aos-delay={index * 50}
            >
                <Stack
                    direction='column'
                    justifyContent='space-between'
                    alignItems='start'
                    width='100%'
                >
                    <Stack
                        direction='column'
                    >
                        <Card
                            elevation={0}
                            sx={{
                                px: 1,
                                backgroundColor: theme.palette.background.default,
                                border: `0.5px solid ${theme.palette.primary.main}`,
                                borderRadius: 2,
                                width: 'fit-content',
                                mb: {xs: 2.5, md: 5}
                            }}
                        >
                            {icon}
                        </Card>

                        <Typography
                            fontWeight={700}
                            fontSize={{xs: 14, md: 24}}
                            textAlign="left"
                            lineHeight={1.25}
                            sx={{
                                pb: {xs: 1, md: 2}
                            }}
                            color={inverse ? 'white' : theme.palette.text.primary}
                        >
                            {title}
                        </Typography>

                        <Typography
                            fontWeight={400}
                            fontSize={{xs: 12, md: 14}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={inverse ? 'white' : theme.palette.text.primary}
                        >
                            {description}
                        </Typography>
                    </Stack>
                </Stack>
            </Card>
        </>
    );
}